module.exports = __webpack_public_path__ + "img/sand-dune-decal-16.0f96f22d.png";